import JsonSources from "./JsonSources";
import ChartTypes from "./ChartTypes";
function _getJson(uri) {
    return fetch(uri, {
        credentials: "same-origin"
    });
}
export default {
    getChartContent: function getChartContent(chart) {
        return _getJson("".concat(JsonSources.chartPath, "/").concat(ChartTypes[chart.target_type].path, "/").concat(chart.target_id, ".json")).then(function(response) {
            return response.json();
        });
    }
};
